import { useMemo } from 'react';
import { useRouter } from 'next/router';
import PersonIcon from '@mui/icons-material/Person';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectPermissionsPinnedFilters,
  togglePinnedFiltersState,
} from '@store';
import { useHasFilters } from 'hooks/common';
import { AGENT_ROLES } from '@constants';

export const usePermissionsFilterConfig = ({ roles }) => {
  const router = useRouter();
  const pinnedFilters = useSelector(selectPermissionsPinnedFilters);
  const dispatch = useDispatch();
  const { hasFilters } = useHasFilters({ pinnedFilters });

  const filterCategories = useMemo(
    () => [
      {
        id: 'role',
        label: 'Role',
        icon: PersonIcon,
        options: roles,
      },
    ],
    [roles]
  );

  const currentFilters = useMemo(() => {
    return {
      role: router.query.role || AGENT_ROLES.isAdmin,
    };
  }, [router.query]);

  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(togglePinnedFiltersState({ board: 'permissions', pinnedFilter }));
  };

  return {
    filterCategories,
    currentFilters,
    supportPinnedFilters: true,
    hasFilters,
    pinnedFilters,
    handlePinnedFilterSelect,
  };
};
